import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'

export const GLOBAL_TILE_MECHANIC_V2_EXP_FLAG = 'pen-4054_v2'

export const useTrackGlobalTileMechanicV2Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(GLOBAL_TILE_MECHANIC_V2_EXP_FLAG)
  }, [])
}
